import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ModalTicketsSinTarifaPage } from './modal-tickets-sin-tarifa.page';

const routes: Routes = [
  {
    path: '',
    component: ModalTicketsSinTarifaPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ModalTicketsSinTarifaPage]
})
export class ModalTicketsSinTarifaPageModule {}
